import { parse } from '../../util/urlHelpers';
import { createNewListing, getOwnJobRfpListings, getUserDetails, conversations, chatMessages, manualTransactions, sendMeetingScheduledMail, sendPostingInvitation, updateTransactionMetadata, updateTransition, fetchPersonaRecords, getAddedUsersOfCompany } from '../../util/api';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { getAllTransitionsForEveryProcess } from '../../transactions/transaction';
import { storableError } from '../../util/errors';
import socket from '../../util/socket';
import { denormalisedResponseEntities } from '../../util/data';
import { userTypeOf } from '../../util/userType';
import { teamRoleOf } from '../../util/teamRole';
import { showPostingListing } from '../../util/postingRead';
import * as log from '../../util/log';

// ================ Action types ================ //

export const FETCH_RFPLISTINGS_REQUEST = 'app/RFPPostsPage/FETCH_RFPLISTINGS_REQUEST';
export const FETCH_RFPLISTINGS_SUCCESS = 'app/RFPPostsPage/FETCH_RFPLISTINGS_SUCCESS';
export const FETCH_RFPLISTINGS_ERROR = 'app/RFPPostsPage/FETCH_RFPLISTINGS_ERROR';

export const FETCH_CANDIDATELISTINGS_REQUEST = 'app/JobPostsPage/FETCH_CANDIDATELISTINGS_REQUEST';
export const FETCH_CANDIDATELISTINGS_SUCCESS = 'app/JobPostsPage/FETCH_CANDIDATELISTINGS_SUCCESS';
export const FETCH_CANDIDATELISTINGS_ERROR = 'app/JobPostsPage/FETCH_CANDIDATELISTINGS_ERROR';

export const FETCH_TRANSACTIONS_REQUEST = 'app/RFPPostsPage/FETCH_TRANSACTIONS_REQUEST';
export const FETCH_TRANSACTIONS_SUCCESS = 'app/RFPPostsPage/FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_ERROR = 'app/RFPPostsPage/FETCH_TRANSACTIONS_ERROR';

export const INITIATE_MESSAGE_TRANSACTION_REQUEST = 'app/RFPPostsPage/INITIATE_MESSAGE_TRANSACTION_REQUEST';
export const INITIATE_MESSAGE_TRANSACTION_SUCCESS = 'app/RFPPostsPage/INITIATE_MESSAGE_TRANSACTION_SUCCESS';
export const INITIATE_MESSAGE_TRANSACTION_ERROR = 'app/RFPPostsPage/INITIATE_MESSAGE_TRANSACTION_ERROR';

export const SEND_INVITATION_TO_USER_REQUEST = 'app/RFPPostsPage/SEND_INVITATION_TO_USER_REQUEST';
export const SEND_INVITATION_TO_USER_SUCCESS = 'app/RFPPostsPage/SEND_INVITATION_TO_USER_SUCCESS';
export const SEND_INVITATION_TO_USER_ERROR = 'app/RFPPostsPage/SEND_INVITATION_TO_USER_ERROR';

export const REJECT_APPLICATION_REQUEST = 'app/RFPPostsPage/REJECT_APPLICATION_REQUEST';
export const REJECT_APPLICATION_SUCCESS = 'app/RFPPostsPage/REJECT_APPLICATION_SUCCESS';
export const REJECT_APPLICATION_ERROR = 'app/RFPPostsPage/REJECT_APPLICATION_ERROR';

export const SCHEDULE_INTERVIEW_REQUEST = 'app/RFPPostsPage/SCHEDULE_INTERVIEW_REQUEST';
export const SCHEDULE_INTERVIEW_SUCCESS = 'app/RFPPostsPage/SCHEDULE_INTERVIEW_SUCCESS';
export const SCHEDULE_INTERVIEW_ERROR = 'app/RFPPostsPage/SCHEDULE_INTERVIEW_ERROR';

export const UPDATE_SCHEDULED_TX_REQUEST = 'app/RFPPostsPage/UPDATE_SCHEDULED_TX_REQUEST';
export const UPDATE_SCHEDULED_TX_SUCCESS = 'app/RFPPostsPage/UPDATE_SCHEDULED_TX_SUCCESS';
export const UPDATE_SCHEDULED_TX_ERROR = 'app/RFPPostsPage/UPDATE_SCHEDULED_TX_ERROR';

export const SEND_SCHEDULED_MAIL_REQUEST = 'app/RFPPostsPage/SEND_SCHEDULED_MAIL_REQUEST';
export const SEND_SCHEDULED_MAIL_SUCCESS = 'app/RFPPostsPage/SEND_SCHEDULED_MAIL_SUCCESS';
export const SEND_SCHEDULED_MAIL_ERROR = 'app/RFPPostsPage/SEND_SCHEDULED_MAIL_ERROR';

export const SHORTLIST_REQUEST = 'app/RFPPostsPage/SHORTLIST_REQUEST';
export const SHORTLIST_SUCCESS = 'app/RFPPostsPage/SHORTLIST_SUCCESS';
export const SHORTLIST_ERROR = 'app/RFPPostsPage/SHORTLIST_ERROR';

export const REVERT_TO_PENDING_REQUEST = 'app/RFPPostsPage/REVERT_TO_PENDING_REQUEST';
export const REVERT_TO_PENDING_SUCCESS = 'app/RFPPostsPage/REVERT_TO_PENDING_SUCCESS';
export const REVERT_TO_PENDING_ERROR = 'app/RFPPostsPage/REVERT_TO_PENDING_ERROR';

export const FETCH_POSTED_BY_OPTIONS_REQUEST = 'app/RFPPostsPage/FETCH_POSTED_BY_OPTIONS_REQUEST';
export const FETCH_POSTED_BY_OPTIONS_SUCCESS = 'app/RFPPostsPage/FETCH_POSTED_BY_OPTIONS_SUCCESS';
export const FETCH_POSTED_BY_OPTIONS_ERROR = 'app/RFPPostsPage/FETCH_POSTED_BY_OPTIONS_ERROR';

export const SET_LOADING_STATE = 'app/JobPostsPage/SET_LOADING_STATE';
export const SET_MESSAGE_TXN_ID = 'app/RFPPostsPage/SET_MESSAGE_TXN_ID';

// ================ Helper Functions ================ //




// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchRFPListingsError: null,
  fetchCandidateListingsError: null,
  fetchTransactionsError: null,
  initiateTransactionError: null,
  sendInvitationToUserError: null,
  rejectApplicationError: null,
  pagination: null,
  rfpListings: null,
  candidateListings: null,
  listingTransactions: null,
  messageTxnId: null,
  inviteSentSuccess: false,
  rejectApplicationSuccess: false,
  inviting: false,
  rejecting: false,
  rejected: false,
  rejectedTxnIds: [],
  scheduledInterviewLinks: null,
  scheduleError: null,
  updateScheduledTxError: null,
  updateScheduledTxSuccess: false,
  updatingScheduledTx: false,
  sendScheduledMailError: null,
  sendScheduledMailSuccess: false,
  sendingScheduledMail: false,
  shortlisting: false,
  shortlistSuccess: false,
  shortlistError: null,
  revertToPendingError: null,
  revertToPendingSuccess: false,
  revertToPending: false,
  loading: false,
  postedByOptions: [],
  fetchPostedByOptionsInProgress: false,
  fetchPostedByOptionsError: null,
};


export default function rfpPostsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;

switch (type) {

    case FETCH_RFPLISTINGS_REQUEST:
      return { ...state, fetchInProgress: true, fetchRFPListingsError: null };
    case FETCH_RFPLISTINGS_SUCCESS: {
      const rfpListings = payload;
      
      return {
        ...state,
        fetchInProgress: false,
        rfpListings: rfpListings,
      }
    }
    case FETCH_RFPLISTINGS_ERROR:
      return { ...state, fetchInProgress: false, fetchRFPListingsError: payload };

    case FETCH_CANDIDATELISTINGS_REQUEST:
      return { ...state, fetchInProgress: true, fetchCandidateListingsError: null };
    case FETCH_CANDIDATELISTINGS_SUCCESS: {
      const candidateListings = payload;
      
      return {
        ...state,
        fetchInProgress: false,
        candidateListings: candidateListings,
      }
    }
    case FETCH_CANDIDATELISTINGS_ERROR:
      return { ...state, fetchInProgress: false, fetchCandidateListingsError: payload }

    case FETCH_TRANSACTIONS_REQUEST:
      return { ...state, fetchInProgress: true, fetchTransactionsError: null };
    case FETCH_TRANSACTIONS_SUCCESS: {
      const listingTransactions = payload;
      return {
        ...state,
        fetchInProgress: false,
        listingTransactions: listingTransactions,
      }
    }
    case FETCH_TRANSACTIONS_ERROR:
      return { ...state, fetchInProgress: false, fetchTransactionsError: payload }

    case INITIATE_MESSAGE_TRANSACTION_REQUEST:
      return { ...state, initiateTransactionError: null };
    case INITIATE_MESSAGE_TRANSACTION_SUCCESS:
      return { ...state, initiateTransactionError: null };
    case INITIATE_MESSAGE_TRANSACTION_ERROR:
      return { ...state, initiateTransactionError: payload };
   
    case SET_MESSAGE_TXN_ID:
      return { ...state, messageTxnId: payload };

    case SEND_INVITATION_TO_USER_REQUEST:
      return { ...state, sendInvitationToUserError: null, inviteSentSuccess: false, inviting: true };
    case SEND_INVITATION_TO_USER_SUCCESS:
      return { ...state, sendInvitationToUserError: null, inviteSentSuccess: true, inviting: false };
    case SEND_INVITATION_TO_USER_ERROR:
      return { ...state, sendInvitationToUserError: payload, inviteSentSuccess: false, inviting: false };

    case REJECT_APPLICATION_REQUEST:
      return { ...state, rejectApplicationError: null, rejected: false, rejectApplicationSuccess: false, rejecting: true };
    case REJECT_APPLICATION_SUCCESS:
      return { 
        ...state, 
        rejectApplicationError: null, 
        rejectApplicationSuccess: true, 
        rejecting: false,
        rejected: true,
        rejectedTxnIds: [...state.rejectedTxnIds, payload],
      };
    case REJECT_APPLICATION_ERROR:
      return { ...state, rejected: false, rejectApplicationError: payload, rejectApplicationSuccess: false, rejecting: false };

    case SCHEDULE_INTERVIEW_REQUEST:
      return { ...state, scheduleError: null };
    case SCHEDULE_INTERVIEW_SUCCESS:
      return { ...state, scheduleError: null, scheduledInterviewLinks: payload };
    case SCHEDULE_INTERVIEW_ERROR:
      return { ...state, scheduleError: payload };

    case UPDATE_SCHEDULED_TX_REQUEST:
      return { ...state, updateScheduledTxError: null, updateScheduledTxSuccess: false, updatingScheduledTx: true };
    case UPDATE_SCHEDULED_TX_SUCCESS:
      return { ...state, updateScheduledTxError: null, updateScheduledTxSuccess: true, updatingScheduledTx: false };
    case UPDATE_SCHEDULED_TX_ERROR:
      return { ...state, updateScheduledTxError: payload, updateScheduledTxSuccess: false, updatingScheduledTx: false };

    case SEND_SCHEDULED_MAIL_REQUEST:
      return { ...state, sendScheduledMailError: null, sendScheduledMailSuccess: false, sendingScheduledMail: true };
    case SEND_SCHEDULED_MAIL_SUCCESS:
      return { ...state, sendScheduledMailError: null, sendScheduledMailSuccess: true, sendingScheduledMail: false };
    case SEND_SCHEDULED_MAIL_ERROR:
      return { ...state, sendScheduledMailError: payload, sendScheduledMailSuccess: false, sendingScheduledMail: false };

    case SHORTLIST_REQUEST:
      return { ...state, shortlistError: null, shortlistSuccess: false, shortlisting: true };
    case SHORTLIST_SUCCESS:
      return { ...state, shortlistError: null, shortlistSuccess: true, shortlisting: false };
    case SHORTLIST_ERROR:
      return { ...state, shortlistError: payload, shortlistSuccess: false, shortlisting: false };

    case REVERT_TO_PENDING_REQUEST:
      return { ...state, revertToPendingError: null, revertToPendingSuccess: false, revertToPending: true };
    case REVERT_TO_PENDING_SUCCESS:
      return { ...state, revertToPendingError: null, revertToPendingSuccess: true, revertToPending: false };
    case REVERT_TO_PENDING_ERROR:
      return { ...state, revertToPendingError: payload, revertToPendingSuccess: false, revertToPending: false };

    case SET_LOADING_STATE:
      return { ...state, loading: payload };

    case FETCH_POSTED_BY_OPTIONS_REQUEST:
      return { ...state, fetchPostedByOptionsInProgress: true, fetchPostedByOptionsError: null };
    case FETCH_POSTED_BY_OPTIONS_SUCCESS:
      return { ...state, fetchPostedByOptionsInProgress: false, postedByOptions: payload };
    case FETCH_POSTED_BY_OPTIONS_ERROR:
      return { ...state, fetchPostedByOptionsInProgress: false, fetchPostedByOptionsError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchRFPListingsRequest = () => ({ type: FETCH_RFPLISTINGS_REQUEST });
const fetchRFPListingsSuccess = response => ({
  type: FETCH_RFPLISTINGS_SUCCESS,
  payload: response,
});
const fetchRFPListingsError = e => ({
  type: FETCH_RFPLISTINGS_ERROR,
  error: true,
  payload: e,
});

const fetchCandidateListingsRequest = () => ({ type: FETCH_CANDIDATELISTINGS_REQUEST });
const fetchCandidateListingsSuccess = response => ({
  type: FETCH_CANDIDATELISTINGS_SUCCESS,
  payload: response,
});
const fetchCandidateListingsError = e => ({
  type: FETCH_CANDIDATELISTINGS_ERROR,
  error: true,
  payload: e,
});

const fetchTransactionsRequest = () => ({ type: FETCH_TRANSACTIONS_REQUEST });
const fetchTransactionsSuccess = response => ({
  type: FETCH_TRANSACTIONS_SUCCESS,
  payload: response,
});
const fetchTransactionsError = e => ({
  type: FETCH_TRANSACTIONS_ERROR,
  error: true,
  payload: e,
});

const initiateMessageTransactionRequest = () => ({ type: INITIATE_MESSAGE_TRANSACTION_REQUEST });
const initiateMessageTransactionSuccess = () => ({ type: INITIATE_MESSAGE_TRANSACTION_SUCCESS });
const initiateMessageTransactionError = e => ({
  type: INITIATE_MESSAGE_TRANSACTION_ERROR,
  error: true,
  payload: e,
});

const sendInvitationToUserRequest = () => ({ type: SEND_INVITATION_TO_USER_REQUEST });
const sendInvitationToUserSuccess = () => ({ type: SEND_INVITATION_TO_USER_SUCCESS });
const sendInvitationToUserError = e => ({
  type: SEND_INVITATION_TO_USER_ERROR,
  error: true,
  payload: e,
});

const rejectApplicationRequest = () => ({ type: REJECT_APPLICATION_REQUEST });
const rejectApplicationSuccess = (txId) => ({ type: REJECT_APPLICATION_SUCCESS, payload: txId });
const rejectApplicationError = e => ({
  type: REJECT_APPLICATION_ERROR,
  error: true,
  payload: e,
});

export const scheduleInterviewRequest = () => ({ type: SCHEDULE_INTERVIEW_REQUEST });
export const scheduleInterviewSuccess = () => ({ type: SCHEDULE_INTERVIEW_SUCCESS });
export const scheduleInterviewError = e => ({
  type: SCHEDULE_INTERVIEW_ERROR,
  error: true,
  payload: e,
});

export const updateScheduledTxRequest = () => ({ type: UPDATE_SCHEDULED_TX_REQUEST });
export const updateScheduledTxSuccess = () => ({ type: UPDATE_SCHEDULED_TX_SUCCESS });
export const updateScheduledTxError = e => ({
  type: UPDATE_SCHEDULED_TX_ERROR,
  error: true,
  payload: e,
});

export const sendScheduledMailRequest = () => ({ type: SEND_SCHEDULED_MAIL_REQUEST });
export const sendScheduledMailSuccess = () => ({ type: SEND_SCHEDULED_MAIL_SUCCESS });
export const sendScheduledMailError = e => ({
  type: SEND_SCHEDULED_MAIL_ERROR,
  error: true,
  payload: e,
});

export const shortListRequest = () => ({ type: SHORTLIST_REQUEST });
export const shortListSuccess = () => ({ type: SHORTLIST_SUCCESS });
export const shortListError = e => ({
  type: SHORTLIST_ERROR,
  error: true,
  payload: e,
});

export const revertToPendingRequest = () => ({ type: REVERT_TO_PENDING_REQUEST });
export const revertToPendingSuccess = () => ({ type: REVERT_TO_PENDING_SUCCESS });
export const revertToPendingError = e => ({
  type: REVERT_TO_PENDING_ERROR,
  error: true,
  payload: e,
});

export const setLoadingState = loading => ({
  type: SET_LOADING_STATE,
  payload: loading,
});

export const setMessageTxnId = messageTxnId => ({
  type: SET_MESSAGE_TXN_ID,
  payload: messageTxnId,
});

const fetchPostedByOptionsRequest = () => ({ type: FETCH_POSTED_BY_OPTIONS_REQUEST });
const fetchPostedByOptionsSuccess = options => ({ type: FETCH_POSTED_BY_OPTIONS_SUCCESS, payload: options });
const fetchPostedByOptionsError = e => ({
  type: FETCH_POSTED_BY_OPTIONS_ERROR,
  error: true,
  payload: e,
});

export const fetchPostedByOptions = () => async (dispatch, getState) => {
  dispatch(fetchPostedByOptionsRequest());

  const state = getState();
  const { currentUser } = state.user;
  const profileListingId =
    currentUser?.attributes?.profile?.publicData?.firstListingId ||
    currentUser?.attributes?.profile?.publicData?.profileListingId;

  if (!profileListingId) {
    dispatch(fetchPostedByOptionsSuccess([]));
    return [];
  }

  try {
    // Only people who have joined can have posted anything. Pending invitations are held by the
    // server for the company's admin alone, so they are not offered here.
    const addedUsersResponse = await getAddedUsersOfCompany({ profileListingId });

    const addedUsers = denormalisedResponseEntities(addedUsersResponse) || [];
    const addedNames = addedUsers
      .map(user => user?.attributes?.profile?.displayName || user?.attributes?.email)
      .filter(Boolean);

    const options = Array.from(new Set(addedNames));
    dispatch(fetchPostedByOptionsSuccess(options));
    return options;
  } catch (error) {
    dispatch(fetchPostedByOptionsError(error));
    throw error;
  }
};

// ================ Thunks ================ //

const RESULT_PAGE_SIZE = 42;
const MESSAGES_PAGE_SIZE = 100;

const getMainAccountId = async (user, sdk) => {
  if (!user) return null;

  const userType = userTypeOf(user);
  const role = teamRoleOf(user);

  if (userType === 'agency' || userType === 'customer') {
    if (role === 'Admin' && user?.attributes?.profile?.publicData?.firstListingId !== undefined) {
      return user.id?.uuid;
    } else {
      const profileListingId = user.attributes?.profile?.publicData?.profileListingId;

      const listingResponse = await sdk.listings.show({ id: profileListingId });
      const listing = listingResponse?.data?.data;

      return listing?.attributes?.publicData?.adminId;
    }
  }

  return user.id?.uuid;
};

const fetchPersonaRecordsForUser = async (profileListingId) => {
  if (!profileListingId) return [];

  try {
    const apiResponse = await fetchPersonaRecords({ profileListingId });
    return apiResponse?.success && apiResponse?.data ? apiResponse.data : [];
  } catch (error) {
    return [];
  }
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const { currentUser } = getState().user;

  if (!currentUser) return null;

  dispatch(setLoadingState(true));

  // Any failure ends the load here, so the page leaves its placeholders and can offer a retry.
  try {
    return await loadRfpPostsPageData(currentUser, search, config, dispatch, sdk);
  } catch (err) {
    log.error(err, 'rfp-posts-load-failed');
    dispatch(fetchRFPListingsError(storableError(err)));
    dispatch(setLoadingState(false));
    return null;
  }
};

// The company owner, their RFP listings and their applications. Throws on failure.
const loadRfpPostsPageData = async (currentUser, search, config, dispatch, sdk) => {
  const mainUserId = await getMainAccountId(currentUser, sdk);

  let queryParams = parse(search);
  const page = queryParams.page || 1;

  dispatch(fetchRFPListingsRequest());

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  queryParams = {
    ...queryParams,
    page,
    perPage: RESULT_PAGE_SIZE,
    include: ['images', 'currentStock'],
    authorId: mainUserId,
    pub_listingType: 'rfp_listing',
    'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    'limit.images': 1,
  };

  let apiQueryParams = queryParams;

  return getOwnJobRfpListings({apiQueryParams, responseFields: ['title', 'description', 'state', 'createdAt', 'publicData', 'privateData']})
    .then(async response => {
      
      const includedMap = (response?.allListings[0]?.included || []).reduce((map, item) => {
        map[item.id.uuid] = item;
        return map;
      }, {});

      const mergedListings = response?.allListings[0]?.data.map(listing => {
        let merged = { ...listing };

        if (listing.relationships) {
          Object.keys(listing.relationships).forEach(relKey => {
            const relData = listing.relationships[relKey]?.data;

            if (Array.isArray(relData)) {
              merged[relKey] = relData.map(r => includedMap[r.id.uuid] || r);
            } else if (relData?.id?.uuid) {
              merged[relKey] = includedMap[relData.id.uuid] || relData;
            }
          });
        }

        return merged;
      });
      
      const mergedCandidateListingsMap = {};

      try {
        dispatch(fetchTransactionsRequest());

        // Fetch all transactions in parallel for all listings
        const transactionPromises = (mergedListings || []).map(rfpListing =>
          manualTransactions({
            providerId: rfpListing?.attributes?.publicData?.adminId,
            listingId: rfpListing?.id?.uuid,
            txType: 'apply',
            type: 'fetch',
          }).then(transactions => ({
            rfpListingId: rfpListing?.id?.uuid,
            rfpListing,
            transactions
          }))
        );

        const allListingTransactions = await Promise.all(transactionPromises);

        // Collect all unique user IDs to batch fetch
        const userIds = new Set();
        const agencyListingIds = new Set();

        allListingTransactions.forEach(({ transactions }) => {
          transactions.forEach(t => {
            if (t?.customerId) userIds.add(t.customerId);
            if (t?.providerId) userIds.add(t.providerId);
          });
        });

        // Batch fetch all users in parallel with error handling
        const userDetailsPromises = Array.from(userIds).map(userId =>
          getUserDetails({
            userId,
            responseFields: [
              'email',
              'profile.displayName',
              'profile.publicData.userType',
              'profile.publicData.profileListingId',
              'profile.publicData.firstListingId',
              'profile.publicData.agencyProfile',
              'profile.publicData.onBoardingInfo',
              'profile.publicData.phoneNumber',
              'profile.publicData.tags',
              'profile.publicData.skills',
              'profile.publicData.certificationsAndAwards',
              'profile.publicData.education',
              'profile.publicData.pastExperience',
              'profile.publicData.currentEmployer',
              'profile.publicData.identityAndWorkAuthorizationDetails',
              'profile.publicData.cityAddress',
              'profile.publicData.stateAddress',
              'profile.publicData.countryAddress',
            ],
            imageFields: [
              'variants.square-small',
              'variants.square-small2x',
              'variants.listing-card',
              'variants.listing-card-2x',
            ],
          })
            .then(response => ({
              userId,
              data: response ? {
                ...response?.data?.data,
                profileImage: response?.data?.included?.[0],
              } : null
            }))
            .catch(() => ({ userId, data: null }))
        );

        const userDetailsResults = await Promise.all(userDetailsPromises);
        const userDetailsMap = new Map(
          userDetailsResults.map(({ userId, data }) => [userId, data])
        );

        // Collect agency profile listing IDs
        userDetailsResults.forEach(({ data }) => {
          if (userTypeOf(data) === "agency") {
            const profileListingId = data?.attributes?.profile?.publicData?.profileListingId;
            if (profileListingId) agencyListingIds.add(profileListingId);
          }
        });

        // Build listings map from already-fetched RFP listings (avoids redundant API calls)
        const listingsMap = new Map();
        allListingTransactions.forEach(({ rfpListingId, rfpListing }) => {
          listingsMap.set(rfpListingId, rfpListing);
        });

        // Batch fetch agency listings in parallel
        const agencyListingPromises = Array.from(agencyListingIds).map(listingId =>
          sdk.listings.show({
            id: listingId,
            include: ["images", "currentStock"],
            "fields.image": [
              "variants.square-small",
              "variants.square-small2x",
              "variants.square-xsmall",
              "variants.square-xsmall2x",
              "variants.listing-card",
              "variants.listing-card-2x",
            ],
            "limit.images": 1,
          }).then(response => ({
            listingId,
            data: {
              ...response?.data?.data,
              images: response?.data?.included,
            }
          }))
          .catch(() => ({ listingId, data: null }))
        );

        const agencyListingResults = await Promise.all(agencyListingPromises);
        const agencyListingsMap = new Map(
          agencyListingResults.map(({ listingId, data }) => [listingId, data])
        );

        const allConvs = await conversations({ actionType: 'list', userId: mainUserId }).catch(() => []);
        const convLookup = new Map(
          (allConvs || []).map(conv => {
            const sortedIds = (conv.participantIds || []).slice().sort();
            return [sortedIds.join('|'), conv.conversationId];
          })
        );

        const messageTransactionParams = [];
        allListingTransactions.forEach(({ rfpListing }) => {
          const rfpListingAdminId = rfpListing?.attributes?.publicData?.adminId;
          const userBId = mainUserId !== rfpListingAdminId ? mainUserId : rfpListingAdminId;
          const key = `${rfpListingAdminId}-${userBId}`;
          if (!messageTransactionParams.some(p => p.key === key)) {
            messageTransactionParams.push({ key, userAId: rfpListingAdminId, userBId });
          }
        });

        const messageTransactionsMap = new Map(
          messageTransactionParams.map(({ key, userAId, userBId }) => {
            const lookupKey = [userAId, userBId].sort().join('|');
            return [key, convLookup.get(lookupKey) || null];
          })
        );

        // Collect all unique profile listing IDs for persona records fetching
        const profileListingIdsForPersona = new Set();
        userDetailsResults.forEach(({ data }) => {
          const profileListingId = data?.attributes?.profile?.publicData?.profileListingId;
          if (profileListingId) {
            profileListingIdsForPersona.add(profileListingId);
          }
        });

        // Batch fetch persona records for all users
        const personaRecordsPromises = Array.from(profileListingIdsForPersona).map(profileListingId =>
          fetchPersonaRecordsForUser(profileListingId)
            .then(personaRecords => ({ profileListingId, personaRecords }))
        );

        const personaRecordsResults = await Promise.all(personaRecordsPromises);
        const personaRecordsMap = new Map(
          personaRecordsResults.map(({ profileListingId, personaRecords }) => [profileListingId, personaRecords])
        );

        // Process all transactions with cached data
        let mergedListingTransactions = [];

        allListingTransactions.forEach(({ rfpListing, transactions }) => {
          const rfpListingAdminId = rfpListing?.attributes?.publicData?.adminId;
          const userBId = mainUserId !== rfpListingAdminId ? mainUserId : rfpListingAdminId;
          const msgTxnKey = `${rfpListingAdminId}-${userBId}`;
          const msgTransactionId = messageTransactionsMap.get(msgTxnKey);

          transactions.forEach(t => {
            const customer = userDetailsMap.get(t?.customerId);
            const provider = userDetailsMap.get(t?.providerId);

            if (!customer) return;

            const listing = listingsMap.get(t?.listingId);

            let finalCustomer = customer;

            // Get persona records for the customer
            const customerProfileListingId = customer?.attributes?.profile?.publicData?.profileListingId;
            const customerPersonaRecords = personaRecordsMap.get(customerProfileListingId) || [];

            // Add agency listing data if customer is agency
            if (userTypeOf(customer) === "agency") {
              const agencyListingId = customer?.attributes?.profile?.publicData?.profileListingId;
              const agencyListing = agencyListingsMap.get(agencyListingId);

              if (agencyListing) {
                finalCustomer = {
                  ...customer,
                  attributes: {
                    ...customer?.attributes,
                    profile: {
                      ...customer?.attributes?.profile,
                      publicData: {
                        ...customer?.attributes?.profile?.publicData,
                        profileListing: agencyListing,
                        personaRecord: customerPersonaRecords,
                      },
                    },
                  },
                };
              } else {
                finalCustomer = {
                  ...customer,
                  attributes: {
                    ...customer?.attributes,
                    profile: {
                      ...customer?.attributes?.profile,
                      publicData: {
                        ...customer?.attributes?.profile?.publicData,
                        personaRecord: customerPersonaRecords,
                      },
                    },
                  },
                };
              }
            } else {
              // For non-agency customers (candidates), still add persona records
              finalCustomer = {
                ...customer,
                attributes: {
                  ...customer?.attributes,
                  profile: {
                    ...customer?.attributes?.profile,
                    publicData: {
                      ...customer?.attributes?.profile?.publicData,
                      personaRecord: customerPersonaRecords,
                    },
                  },
                },
              };
            }

            mergedListingTransactions.push({
              ...t,
              customer: finalCustomer,
              provider: provider,
              listing: listing,
              msgTransactionId: msgTransactionId,
            });
          });
        });

        dispatch(fetchTransactionsSuccess(mergedListingTransactions));
      } catch (error) {
        dispatch(fetchTransactionsError(storableError(error)));
      }

      dispatch(fetchRFPListingsSuccess(mergedListings));

      dispatch(setLoadingState(false));
      
      return mergedListings;
    });
};


export const getTransactionsBetweenUsers = (userId1, listingId) => async (dispatch, getState, sdk) => {
  if (!userId1) return null;

  const state = getState();
  const { currentUser } = state.user;
  if (!currentUser) return null;
  
  const mainUserId = await getMainAccountId(currentUser, sdk);
  if (!mainUserId) return null;


  try {
    let userIdUser = await sdk.users.show({ id: userId1 });
    userIdUser = userIdUser?.data?.data;
    
    const userMainUserId = await getMainAccountId(userIdUser, sdk);
    
    const conv = await conversations({ actionType: 'getOrCreate', senderId: mainUserId, receiverId: userMainUserId });

    dispatch(setMessageTxnId(conv?.conversationId || null));
    return conv?.conversationId || null;
    
  } catch (error) {
    return null;
  }

};

export const initiateTransactionForMessage = (userId, listingId, message, config) => async (dispatch, getState, sdk) => {
  if (!userId || !listingId) return null;
  dispatch(initiateMessageTransactionRequest());

  const state = getState();
  const { currentUser } = state.user;
  if (!currentUser) return null;
  const mainUserId = await getMainAccountId(currentUser, sdk);
  if (!mainUserId) return null;
  
  let userProfileListing = await sdk.listings.show({ id: listingId });
  userProfileListing = userProfileListing?.data?.data;
  const userProfileListingAdminId = userProfileListing?.attributes?.publicData?.adminId;

  try {
    const conv = await conversations({ actionType: 'getOrCreate', senderId: mainUserId, receiverId: userProfileListingAdminId });
    const conversationId = conv?.conversationId;

    await chatMessages({
      actionType: 'send',
      conversationId,
      senderId: mainUserId,
      receiverId: userProfileListingAdminId,
      text: message,
      attachments: [],
    });

    dispatch(initiateMessageTransactionSuccess());
    return conversationId;
  } catch (err) {
    dispatch(initiateMessageTransactionError(storableError(err)));
    return false;
  }
};

export const sendInvitationToUser = (listingId, listingName, toEmail, toUserId, invitedUserName, toUserType, toUserProfileListingId, isJobPosting, isRFPPosting) => async (dispatch, getState, sdk) => {
  
  if (!toUserId || !listingId) return null;
  dispatch(sendInvitationToUserRequest());

  const state = getState();
  const { currentUser } = state.user;
  if (!currentUser) return null;

  const mainUserId = await getMainAccountId(currentUser, sdk);
  if (!mainUserId) return null;

  let mainUser = null;

  if(currentUser?.id?.uuid === mainUserId) {
    mainUser = currentUser;
  } else {
    try {
      const mainUserResponse = await sdk.users.show({ id: mainUserId });
      mainUser = mainUserResponse?.data?.data;
    } catch(error) {
      mainUser = currentUser;
    }
  }

  const mainUserName = mainUser?.attributes?.profile?.displayName || currentUser?.attributes?.profile?.displayName || "";
  
  const adminName = mainUserName || "Admin";
  let orgName = "";
  
  try {
    let mainListing = await sdk.listings.show({ id: currentUser?.attributes?.profile?.publicData?.profileListingId || currentUser?.attributes?.profile?.publicData?.firstListingId });
    
    mainListing = mainListing?.data?.data;
    orgName = mainUser?.attributes?.profile?.publicData?.customerProfile?.name || "";

  } catch(error) {
    return;
  }

  return sendPostingInvitation({ listingId, listingName, adminName, orgName, toUserId, invitedRole: toUserType, isJobPosting: isJobPosting, isRFPPosting: isRFPPosting, invitedUserName, res: null })
    .then(() => {
      // The server has already added the invitee to the posting's invite list.
      dispatch(sendInvitationToUserSuccess());
      return true;
    })
    .catch(e => {
      dispatch(sendInvitationToUserError(storableError(e)));
      return false;
    });

};

export const rejectApplication = (txId) => async (dispatch, getState, sdk) => {
  
  if (!txId) return null;
  dispatch(rejectApplicationRequest());

  let toSendPayload = {
    transactionId: txId,
    type: 'update',
    status: 'rejected',
  };

  const state = getState();
  const { currentUser } = state.user;
  const txn = await manualTransactions({ transactionId: txId, type: 'fetch' });
  const txnListingId = txn[0]?.listingId;

  const mainAccountId = await getMainAccountId(currentUser, sdk);
  if (!mainAccountId) return null;
  let applierId = mainAccountId === txn[0]?.providerId ? txn[0]?.customerId : txn[0]?.providerId;

  return manualTransactions(toSendPayload)
    .then(async () => {
      dispatch(rejectApplicationSuccess(txId));

      try {
        let txnListing = await showPostingListing(sdk, { id: txnListingId });
        txnListing = txnListing?.data?.data;

        let allAppliers = txnListing?.attributes?.publicData?.rejected || [];
        // const applierListingId = currentUser?.attributes?.profile?.publicData?.firstListingId || currentUser?.attributes?.profile?.publicData?.profileListingId;
        allAppliers = [...(allAppliers || []), applierId];
        
        await createNewListing({ jobListingId: txnListingId, rejectApplications: true, rejected: allAppliers});

      } catch (err) {
        // Non-critical: primary action succeeded, listing metadata update failed
      }

      return true;
    })
    .catch(e => {
      dispatch(rejectApplicationError(storableError(e)));
      return false;
    });
  
};

export const scheduleInterview = (txId, startTime, userMail, description, summary) => async (dispatch, getState, sdk) => {
  if (!txId) return null;
  dispatch(scheduleInterviewRequest());

  let meetingDetails = {
    // startTime: '2025-09-30T14:30:00+05:30',
    startTime: startTime,
    summary: summary,
    description: description,
    attendees: [`${userMail}`],
  };

  try {
    window.location.href = `http://localhost:4000/api/auth/googleMeet?` + new URLSearchParams({
      ...meetingDetails,
      attendees: JSON.stringify(meetingDetails.attendees),
    });
  } catch (error) {
    dispatch(scheduleInterviewError(storableError(error)));
  }
};

export const updateScheduledTx = (txId, scheduleDate, meetLink, eventId, meetingHeading, meetingDescription) => async (dispatch, getState, sdk) => {
  if (!txId) return null;
  dispatch(updateScheduledTxRequest());

  const state = getState();
  const { currentUser } = state.user;
  const txn = await manualTransactions({ transactionId: txId, type: 'fetch' });
  const txnListingId = txn[0]?.listingId;

  const mainAccountId = await getMainAccountId(currentUser, sdk);
  if (!mainAccountId) return null;
  let applierId = mainAccountId === txn[0]?.providerId ? txn[0]?.customerId : txn[0]?.providerId;

  return manualTransactions({
      transactionId: txId,
      type: 'update',
      status: 'scheduled',
      scheduleDate: scheduleDate,
      meetLink: meetLink,
      eventId: eventId,
      meetingHeading: meetingHeading,
      meetingDescription: meetingDescription,
    })
    .then(async () => {
      dispatch(updateScheduledTxSuccess());

      try {
        let txnListing = await showPostingListing(sdk, { id: txnListingId });
        txnListing = txnListing?.data?.data;

        let allAppliers = txnListing?.attributes?.publicData?.scheduled || [];
        // const applierListingId = currentUser?.attributes?.profile?.publicData?.firstListingId || currentUser?.attributes?.profile?.publicData?.profileListingId;
        allAppliers = [...(allAppliers || []), applierId];
        
        await createNewListing({ jobListingId: txnListingId, scheduleApplications: true, scheduled: allAppliers});

      } catch (err) {
        // Non-critical: primary action succeeded, listing metadata update failed
      }

      return true;
    })
    .catch(e => {
      dispatch(updateScheduledTxError(storableError(e)));
      return false;
    });

};

// The server addresses the mail from the application itself, so only its id is sent; the address
// parameters stay in the signature for existing call sites and are not sent.
export const sendScheduledMail = (userMail, userName, meetingLink, listingName, meetingDate, meetingTime, schedulerMail, meetingScheduledWithMail, isCandidate, transactionId) => async (dispatch, getState, sdk) => {
  if (!transactionId) return null;
  dispatch(sendScheduledMailRequest());

  const state = getState();
  const { currentUser } = state.user;
  if (!currentUser) return null;

  return sendMeetingScheduledMail({ transactionId, userName, meetingLink, meetingDate, meetingTime, isCandidate })
    .then(() => {
      dispatch(sendScheduledMailSuccess());
      return true;
    })
    .catch(e => {
      dispatch(sendScheduledMailError(storableError(e)));
      return false;
    });
};

export const shortListApplication = (txId) => async (dispatch, getState, sdk) => {
  
  if (!txId) return null;
  dispatch(shortListRequest());

  const state = getState();
  const { currentUser } = state.user;
  const txn = await manualTransactions({ transactionId: txId, type: 'fetch' });
  const txnListingId = txn[0]?.listingId;

  const mainAccountId = await getMainAccountId(currentUser, sdk);
  if (!mainAccountId) return null;
  let applierId = mainAccountId === txn[0]?.providerId ? txn[0]?.customerId : txn[0]?.providerId;

  let toSendPayload = {
    transactionId: txId,
    type: 'update',
    status: 'shortlisted',
  };

  return manualTransactions(toSendPayload)
    .then(async () => {
      dispatch(shortListSuccess(txId));

      try {
        let txnListing = await showPostingListing(sdk, { id: txnListingId });
        txnListing = txnListing?.data?.data;

        let allAppliers = txnListing?.attributes?.publicData?.shortlisted || [];
        // const applierListingId = currentUser?.attributes?.profile?.publicData?.firstListingId || currentUser?.attributes?.profile?.publicData?.profileListingId;
        allAppliers = [...(allAppliers || []), applierId];
        
        await createNewListing({ jobListingId: txnListingId, shortlistApplications: true, shortlisted: allAppliers});

      } catch (err) {
        // Non-critical: primary action succeeded, listing metadata update failed
      }

      return true;
    })
    .catch(e => {
      dispatch(shortListError(storableError(e)));
      return false;
    });
};

export const revertToPending = (txId) => async (dispatch, getState, sdk) => {
  
  if (!txId) return null;
  dispatch(revertToPendingRequest());

  const state = getState();
  const { currentUser } = state.user;
  const txn = await manualTransactions({ transactionId: txId, type: 'fetch' });
  const txnListingId = txn[0]?.listingId;

  const mainAccountId = await getMainAccountId(currentUser, sdk);
  if (!mainAccountId) return null;
  let applierId = mainAccountId === txn[0]?.providerId ? txn[0]?.customerId : txn[0]?.providerId;

  let toSendPayload = {
    transactionId: txId,
    type: 'update',
    status: 'pending',
  };

  return manualTransactions(toSendPayload)
    .then(async () => {
      dispatch(revertToPendingSuccess(txId));

      try {
        let txnListing = await showPostingListing(sdk, { id: txnListingId });
        txnListing = txnListing?.data?.data;

        let allAppliers = txnListing?.attributes?.publicData?.shortlisted || [];
        // const applierListingId = currentUser?.attributes?.profile?.publicData?.firstListingId || currentUser?.attributes?.profile?.publicData?.profileListingId;
        allAppliers = [...(allAppliers || []), applierId];
        
        await createNewListing({ jobListingId: txnListingId, shortlistApplications: true, shortlisted: allAppliers});

      } catch (err) {
        // Non-critical: primary action succeeded, listing metadata update failed
      }

      return true;
    })
    .catch(e => {
      dispatch(revertToPendingError(storableError(e)));
      return false;
    });
};